import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { PreviewDocumentComponent } from 'src/app/sidebar-widget/preview-document/preview-document.component';
import { Delivery } from 'src/models/delivery.model';

@Component({
   selector: 'app-documents-for-sending',
   templateUrl: './documents-for-sending.component.html',
   styleUrls: ['./documents-for-sending.component.scss'],
})
export class DocumentsForSendingComponent {
   documents: any[] = [];
   selectedDocuments = new Set<string>();
   centers = [];
   filteredCenters: Observable<any>;
   centerControl = new FormControl('');
   commentControl = new FormControl('');

   constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialogRef: MatDialogRef<DocumentsForSendingComponent>,
      public dialog: MatDialog,
   ) {
      this.documents = data.documents || [];
      this.centers = data.centers || [];
      this.filteredCenters = this.centerControl.valueChanges.pipe(
         startWith(''),
         map(value => (typeof value === 'string' ? value : value?.name)),
         map(name => (name ? this.centers.filter(center => center.name.toLowerCase().includes(name.toLowerCase())) : this.centers.slice())),
      );
      this.documents.forEach(document => {
         this.selectedDocuments.add(document.documentId);
      });
   }

   isSelected(document: any): boolean {
      return this.selectedDocuments.has(document.documentId);
   }

   toggleDocument(document: any, checked: boolean): void {
      if (checked) {
         this.selectedDocuments.add(document.documentId);
      } else {
         this.selectedDocuments.delete(document.documentId);
      }
   }

   get allSelected(): boolean {
      return this.documents.length > 0 && this.documents.every(document => this.selectedDocuments.has(document.documentId));
   }

   get someSelected(): boolean {
      return this.selectedDocuments.size > 0 && !this.allSelected;
   }

   toggleAll(checked: boolean): void {
      if (checked) {
         this.documents.forEach(document => this.selectedDocuments.add(document.documentId));
      } else {
         this.selectedDocuments.clear();
      }
   }

   confirm(): void {
      const selected = this.documents.filter(document => this.selectedDocuments.has(document.documentId));
      this.dialogRef.close({ event: 'Add', data: this.makeBody() });
   }

   makeBody() {
      const body = new Delivery();
      body.ouId = this.centerControl.value?.ouId;
      body.csrId = this.centerControl.value?.id;
      body.csrName = this.centerControl.value?.name;
      body.papers = this.documents.filter(document => this.selectedDocuments.has(document.documentId));
      body.comment = this.commentControl.value == null ? '' : this.commentControl.value;
      return body;
   }

   close() {
      this.dialogRef.close({ event: 'Cancel' });
   }

   trackByDocumentId(index: number, document: any): string {
      return document.documentId;
   }
   displayCustomFormat(objectValue: any): string {
      return objectValue ? objectValue.name : objectValue;
   }
}
